// extracted by mini-css-extract-plugin
export var option = "_br-0";
export var optionCard = "_br-f";
export var optionContent = "_br-g";
export var optionIcon = "_br-i";
export var optionIconBox = "_br-h";
export var optionLabel = "_br-j";
export var optionPill = "_br-m";
export var optionPillBadge = "_br-p";
export var optionPillIcon = "_br-n";
export var optionPillLabel = "_br-o";
export var optionRadio = "_br-k";
export var optionRadioInner = "_br-l";
export var optionReveal = "_br-2";
export var optionRevealDelay0 = "_br-3";
export var optionRevealDelay1 = "_br-4";
export var optionRevealDelay10 = "_br-d";
export var optionRevealDelay11 = "_br-e";
export var optionRevealDelay2 = "_br-5";
export var optionRevealDelay3 = "_br-6";
export var optionRevealDelay4 = "_br-7";
export var optionRevealDelay5 = "_br-8";
export var optionRevealDelay6 = "_br-9";
export var optionRevealDelay7 = "_br-a";
export var optionRevealDelay8 = "_br-b";
export var optionRevealDelay9 = "_br-c";
export var optionSelected = "_br-1";